import React, { createContext, FC, ReactElement, ReactNode, useState } from 'react';

export interface NavigationItem {
  title: string;
  icon: ReactElement;
  navigatePath?: string;
  navigateHash?: string;
}

interface BackNavigationItem {
  title: string;
  onBack?: () => void;
}

export enum SystemNavigationItemType {
  Notifiactions,
  Organizations,
  Connections,
  Support,
}

interface NavigationContent {
  items: NavigationItem[];
  backItem?: BackNavigationItem;
  hiddenSystemItems?: SystemNavigationItemType[];
}

interface NavigationContextProps {
  navigationContent?: NavigationContent;
  setNavigationContent: (content: NavigationContent) => void;
}

interface NavigationProviderProps {
  children: ReactNode;
}

const NavigationContext = createContext<NavigationContextProps>({
  navigationContent: undefined,
  setNavigationContent: undefined,
});

export const NavigationProvider: FC<NavigationProviderProps> = ({ children }) => {
  const [navigationContent, setNavigationContent] = useState<NavigationContent>(undefined);

  return (
    <NavigationContext.Provider
      value={{
        navigationContent,
        setNavigationContent,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext: () => NavigationContextProps = () => {
  return React.useContext(NavigationContext);
};
